import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useListCategoriesQuery, type CategoryType } from '~/types/types'

// Props definition

export default /*#__PURE__*/_defineComponent({
  __name: 'Categories',
  props: {
    value: null,
    modelValue: null,
    columns: null,
    height: null
  },
  emits: ["input", "update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', v: string[]): void
  (e: 'update:modelValue', v: string[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: string[]
  modelValue?: string[]
  columns?: string[]
  height?: string
};





const defaultColumns = ['name']

const currentIds = computed<string[]>(() =>
  props.modelValue !== undefined
    ? props.modelValue
    : props.value ?? [],
)

function onInput(v: string[]) {
  emit('update:modelValue', v)
  emit('input', v)
}

const headers = computed(() =>
  [
    { value: 'id', sortable: true },
    { value: 'label' },
    { value: 'parent.id' },
    { value: 'parent.label' },
    { value: 'createdAt' },
    { value: 'actions' },
  ]
    .filter((o) => (props.columns ?? defaultColumns).includes(o.value))
    .map((col) => ({ ...col, sortable: !!col.sortable })),
)

const options = ref({ page: 1, itemsPerPage: 10, sortDesc: [true] })
const search = ref('')

const variables = computed(() => ({
  input: { text: search.value }, // TODO use type for input + search is not working properly
  offset: options.value.itemsPerPage * (options.value.page - 1),
  limit: options.value.itemsPerPage,
}))

const { result, refetch, loading } = useListCategoriesQuery(variables)

const items = computed<CategoryType[]>(() => result.value?.listCategories ?? [])
const itemCount = computed(() => result.value?.countCategories ?? 0)


return { __sfc: true,props, emit, defaultColumns, currentIds, onInput, headers, options, search, variables, result, refetch, loading, items, itemCount }
}

})